import React from "react";
import {
  Github,
  Linkedin,
  Globe,
  Dribbble,
  BookOpen,
  FileText,
  Code,
  MessageSquare,
} from "lucide-react";

const SOCIAL_PLATFORMS = [
  {
    key: "github",
    label: "GitHub",
    icon: Github,
    placeholder: "https://github.com/username",
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    icon: Linkedin,
    placeholder: "https://linkedin.com/in/username",
  },
  {
    key: "portfolio",
    label: "Portfolio",
    icon: Globe,
    placeholder: "https://yourportfolio.com",
  },
  {
    key: "dribbble",
    label: "Dribbble",
    icon: Dribbble,
    placeholder: "https://dribbble.com/username",
  },
  {
    key: "kaggle",
    label: "Kaggle",
    icon: BookOpen,
    placeholder: "https://kaggle.com/username",
  },
  {
    key: "medium",
    label: "Medium",
    icon: FileText,
    placeholder: "https://medium.com/@username",
  },
  {
    key: "leetcode",
    label: "LeetCode",
    icon: Code,
    placeholder: "https://leetcode.com/username",
  },
  {
    key: "stackoverflow",
    label: "Stack Overflow",
    icon: MessageSquare,
    placeholder: "https://stackoverflow.com/users/username",
  },
];

const SocialLinksInput = ({ socialLinks = {}, onChange, disabled = false }) => {
  const handleChange = (key, value) => {
    const updated = { ...socialLinks, [key]: value };
    onChange(updated);
  };

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {SOCIAL_PLATFORMS.map((platform) => {
          const Icon = platform.icon;
          const value = socialLinks[platform.key] || "";

          return (
            <div key={platform.key}>
              <label className="block text-xs text-gray-500 mb-1">
                {platform.label}
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Icon className="h-4 w-4 text-gray-400" />
                </div>
                <input
                  type="url"
                  value={value}
                  onChange={(e) => handleChange(platform.key, e.target.value)}
                  disabled={disabled}
                  placeholder={platform.placeholder}
                  className="pl-10 block w-full border border-gray-200 rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary-500 disabled:bg-gray-50"
                />
              </div>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-gray-500">
        💡 These links help AI understand your background and provide better
        recommendations
      </p>
    </div>
  );
};

export default SocialLinksInput;
